import { currentEnvironment } from '@/shell/environment';

/**
 * Registers `public/sw.js` (#303) in the deployed builds only: production and staging. Development
 * and the end-to-end `test` build run without it, so nothing there can be served by a worker.
 * A failure to register is not an error the user can act on: the app works the same without it.
 */
export function registerServiceWorker(
  environment: string = currentEnvironment(),
  container: ServiceWorkerContainer | undefined = navigator.serviceWorker,
): void {
  if ((environment !== 'production' && environment !== 'staging') || container === undefined) {
    return;
  }
  window.addEventListener('load', () => {
    container.register('/sw.js').catch(() => undefined);
  });
}
